import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
import React, { useLayoutEffect, useState } from "react";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
  },
}));

export default function InputSelect(props) {
  const classes = useStyles();
  const [id, setId] = useState("");
  const [open, setOpen] = useState(false);

  const handleChange = (event) => {
    // setId(event.target.value);
    // props.setSelectValue(event.target.value);
      const selectedValue = event.target.value;
      setId(selectedValue); 
      props.setSelectValue(selectedValue); 
      console.log(event.target.value)
  };

  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);

  useLayoutEffect(() => {
    if (
      props.data?.length > 0 &&
      props.startValue !== null &&
      props.startValue !== undefined
    ) {
      setId(props.startValue);
    }
  }, [props.data, props.startValue]);

  const config = {
    Book: { value: "idBook", desc: "description" },
    Sports: { value: "idSport", desc: "sportName" },
    Grouping: { value: "idGrouping", desc: "groupName" },
    League: {
      value: "idLeague",
      desc: "description",
      defaultItem: (
        <MenuItem value="-1">
          <span>All</span>
        </MenuItem>
      ),
    },
    Type: { value: "idGameType", desc: "description" },
    Tournament: { value: "id", desc: "description" },
    DataFormatter: { value: "value", desc: "text" },
    Agent: { value: "value", desc: "text" },
    default: { value: "idLineType", desc: "description" },
  };

  const { value, desc, defaultItem } =
    config[props.placeholder] || config.default;

  return (
    <FormControl
      disabled={props.disabled}
      className={`${classes.formControl} ${props.classes} ${props.className}`}
      size={props.size}
      variant={props.variant}
    >
      {props.label && (
        <InputLabel shrink id={props.label}>
          {props.label}
        </InputLabel>
      )}
      <Select
        labelId={props.label}
        open={open}
        onClose={handleClose}
        onOpen={handleOpen}
        value={id}
        onChange={handleChange}
      >
        {defaultItem}
        {props.data &&
          props.data.map((row, index) => (
            <MenuItem
              key={`${row[value] ?? "item"}-${index}`} // ✅ clave garantizada única
              value={row[value]}
            >
              <span>{row[desc]}</span>
            </MenuItem>
          ))}
      </Select>
      {!props.label && props.placeholder && (
        <FormHelperText>{props.placeholder}</FormHelperText>
      )}
    </FormControl>
  );
}
